import React, { memo } from 'react';
import { observer } from 'mobx-react-lite';
import {
  ListItem,
  popupStore,
  ListElemText,
  ListItemCell,
  ListItemCont,
  ListElemImage,
} from '@pascal/pascal-core';

import { StatusRenderer } from './statusMapper';
import pfCheck from '../../assets/images/core/pf-check.png';

const ItemRenderComp = observer(({ result, openCheckHash, status }) => {
  const { currentData } = popupStore;

  return (
    <>
      <ListItemCont key={result?.roundId}>
        <ListItem isSelected={currentData?.roundId === result?.roundId}>
          <ListItemCell>
            <ListElemText>{result?.roundId}</ListElemText>
          </ListItemCell>
          <ListItemCell>
            <StatusRenderer status={status} result={result} />
          </ListItemCell>
          <ListItemCell>
            <ListElemImage name={result?.roundId} onClick={openCheckHash} imageSrc={pfCheck} />
          </ListItemCell>
        </ListItem>
      </ListItemCont>
    </>
  );
});

ItemRenderComp.displayName = 'ItemRender';
export const RenderResultItem = memo(ItemRenderComp);
